import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, AlertCircle, ArrowLeft } from "lucide-react";
import { useAuthStore } from "@/store/authStore";
import { mockSsoLogin } from "@/services/mock/users";
import { apiConfig } from "@/services/api";

/**
 * SSO 占位 ·
 *  - mock 模式：800ms 后伪装成功登 tech_admin
 *  - 真 API 模式：后端 /api/v1/auth/* 暂无 SSO endpoint（per auth/routes.py · v1）
 *    → 展示"v1 暂未启用 SSO"提示 · 引导回邮箱密码登录
 */
export function SSOPage() {
  const navigate = useNavigate();
  const loginSuccess = useAuthStore((s) => s.loginSuccess);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  useEffect(() => {
    if (!apiConfig.useMock) {
      setErrorMsg("v1 暂未启用 Google Workspace SSO · 请使用邮箱密码登录");
      return;
    }
    const timer = setTimeout(() => {
      const u = mockSsoLogin("hao@youtu.travel");
      if (u) {
        loginSuccess(u, {
          accessToken: `mock-sso-${u.id}`,
          refreshToken: `mock-sso-refresh-${u.id}`,
          expiresIn: 3600,
        });
        navigate("/", { replace: true });
      }
    }, 800);
    return () => clearTimeout(timer);
  }, [loginSuccess, navigate]);

  if (errorMsg) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-paper p-6">
        <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50">
            <AlertCircle className="h-6 w-6 text-amber-600" />
          </div>
          <h1 className="mb-1 text-lg font-semibold text-slate-900">SSO 暂未启用</h1>
          <p className="mb-5 text-[13px] text-slate-500">{errorMsg}</p>
          <Link
            to="/login"
            className="inline-flex h-10 items-center gap-1.5 rounded-lg bg-blue-600 px-4 text-[13px] font-semibold text-white hover:bg-blue-700"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> 返回登录
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        <span className="text-[13px] text-slate-600">Google Workspace SSO 验证中...</span>
      </div>
    </div>
  );
}
